import { impalaApi } from "@/main";
import { getImageType } from "@/composable/useGetImageType";

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const handleImages = async (
  projectId: string | undefined,
  stimuliUUID: string,
  files: Array<File>
) => {
  if (files.length) {
    const res = await impalaApi.post(
      `/client-dashboard/projects/${projectId}/stimuli/${stimuliUUID}`,
      {
        fileName: files[0].name,
      }
    );

    fetch(res.data, {
      method: "PUT",
      headers: {
        "Content-Type": getImageType(files[0].name).toString(),
      },
      body: files[0],
    })
      .then((response) => {
        console.log(response);
      })
      .catch((error) => {
        console.error("Error uploading image:", error);
      });
  }

  return {
    handleImages,
  };
};
